import React from 'react';

const Header = () => {
  return (
    <header>
      <h1>Link Sharing App</h1>
      <p>Share your favorite content easily</p>
    </header>
  );
};

export default Header;
